<template>
  <div class="main">
    <div class="nav">
      <Nav :title="'客户面访'" :arrow="false"></Nav>
    </div>
    <!-- 内容 -->
    <div class="content">
      <!-- 标签 -->
      <div>
        <van-tabs @click="onClick" color="#FBAC01">
          <van-tab title="客户">
            <div class="kuhuList scroll-container" @scroll="handleScroll">
              <van-tabs type="card" color="#FBAC01" v-model="clientvaluenum" @click="neibuclick">
                <van-tab title="全部客户">
                  <div><van-search v-model="uservalue" @input="userinput" placeholder="请输入搜索关键词" /></div>
                  <kuhuList :clientlist="clientlist" :name="'客户'" :name1="'全部客户'"></kuhuList>
                </van-tab>
                <van-tab title="拜访任务">
                  <div><van-search v-model="uservalue" @input="userinput" placeholder="请输入搜索关键词" /></div>
                  <kuhuList :clientlist="clientlist" :name="'客户'" :name1="'拜访任务'"></kuhuList>
                </van-tab>
                <van-tab title="线索转换">
                  <div><van-search v-model="uservalue" @input="userinput" placeholder="请输入搜索关键词" /></div>
                  <kuhuList :clientlist="clientlist" :name="'客户'" :name1="'线索转换'"></kuhuList>
                </van-tab>
                <van-tab title="高开工设备">
                  <div><van-search v-model="uservalue" @input="userinput" placeholder="请输入搜索关键词" /></div>
                  <kuhuList :clientlist="clientlist" :name="'高开工设备'" :name1="'高开工设备'"
                    @onClicknoFollowUp="onClicknoFollowUp"></kuhuList>
                </van-tab>
              </van-tabs>
            </div>
          </van-tab>
          <van-tab title="大客户">
            <div class="kuhuList scroll-container" @scroll="handleScroll">
              <van-tabs type="card" color="#FBAC01" v-model="clientvaluenum" @click="neibuclick">
                <van-tab title="全部客户">
                  <div><van-search v-model="uservalue" @input="userinput" placeholder="请输入搜索关键词" /></div>
                  <kuhuList :clientlist="clientlist" :name="'客户'" :name1="'全部客户'"></kuhuList>
                </van-tab>
                <van-tab title="拜访任务">
                  <div><van-search v-model="uservalue" @input="userinput" placeholder="请输入搜索关键词" /></div>
                  <kuhuList :clientlist="clientlist" :name="'客户'" :name1="'拜访任务'"></kuhuList>
                </van-tab>
                <van-tab title="线索转换">
                  <div><van-search v-model="uservalue" @input="userinput" placeholder="请输入搜索关键词" /></div>
                  <kuhuList :clientlist="clientlist" :name="'客户'" :name1="'线索转换'"></kuhuList>
                </van-tab>
              </van-tabs>
            </div>
          </van-tab>
          <van-tab title="商机">
            <div class="kuhuList scroll-container" @scroll="handleScroll">
              <div><van-search v-model="uservalue" @input="shangjiinput" placeholder="请输入搜索关键词" /></div>
              <kuhuList class="kuhuList" :clientlist="clientlist" :name="'商机'" :name1="'商机'"></kuhuList>
            </div>
          </van-tab>
          <van-tab title="出差申请">
            <kuhuList class="kuhuList" :clientlist="clientlist" :name="'出差申请'" :name1="'出差申请'"></kuhuList>
          </van-tab>
        </van-tabs>
      </div>
    </div>
    <div class="footer">
      <fooalt :active="0"></fooalt>
    </div>
    <!-- loading -->
    <van-overlay :show="show">
      <div style="width: 100%;height: 100%;display: grid;place-items: center;">
        <van-loading type="spinner" color="#1989fa" />
      </div>
    </van-overlay>
  </div>
</template>

<script>
import Nav from './component/nav.vue';
import kuhuList from './component/kuhuList.vue';
import fooalt from './component/fooalt.vue';
import { qiweiAPI } from '../../api/qiwei.js';
export default {
  data() {
    return {
      clientlist: [],
      chuchailist: [],
      clientvalue: '客户',
      clientvalue2: '全部客户',
      show: false,
      uservalue: '',
      clientvaluenum: 0,
      totalitems: 0,
      page: 1,
      flage: true,

    }
  },
  beforeCreate() {
    console.log(this.code);
  },
  mounted() {
    // console.log(this.$t);  
    console.log(this.$route.query)
    const urlParams = new URLSearchParams(window.location.search);
    const urlhash = new URLSearchParams(window.location.hash.split("?")[1]);
    const code = urlParams.get("code") || urlhash.get("code");
    this.getCustomersData({
      customer: '客户',
      type: '全部客户',
      qw_user_id: this.$t.qiwei_yuangong_num,
    })
    if (this.$t.codefalse == 2) {
      this.getCustomersData({
        customer: '客户',
        type: '全部客户',
        qw_user_id: this.$t.qiwei_yuangong_num,
      })
    } else {
      this.getuserinfo({ code })
    }


  },
  methods: {
    // 页面滚动事件
    handleScroll(event) {
      const { scrollTop, scrollHeight, clientHeight } = event.target;
      // 检查是否已经滚动到底部或右边
      if (this.clientvalue == '客户' || this.clientvalue == '大客户') {
        if (this.flage == true) {
          if (scrollTop + clientHeight >= scrollHeight - 20) {
            this.show = true
            this.flage = false
            this.page = this.page + 1
            // this.loadMore(); // 触发加载更多数据的方法
            // 是否为高开工
            if (this.clientvalue2 == '高开工设备') {
              var params = {
                qw_user_id: this.$t.qiwei_yuangong_num,
                khbmccc: this.uservalue,
                page: this.page,
                limit: '5'
              }
              this.$axios
                .get(qiweiAPI.getDeviceCustome, {
                  params,
                  headers: this.$t.headers,
                })
                .then((res) => {
                  console.log(res)
                  if (res.data.code == 1) {
                    this.flage = true
                    this.show = false
                    this.clientlist = this.clientlist.concat(res.data.data.data)
                  } else {
                    this.show = false
                  }
                })
                .catch((res) => {
                  console.log(res);
                });

            } else {
              var params = {
                customer: this.clientvalue,
                type: this.clientvalue2,
                qw_user_id: this.$t.qiwei_yuangong_num,
                khbmccc: this.uservalue,
                page: this.page,
                limit: '5'
              }
              this.$axios
                .get(qiweiAPI.getCustomersData, {
                  params,
                  headers: this.$t.headers,
                })
                .then((res) => {
                  console.log(res)
                  if (res.data.code == 1) {
                    this.flage = true
                    this.show = false
                    if (res.data.data.data.length > 0) {
                      this.clientlist = this.clientlist.concat(res.data.data.data)
                    }
                  } else {
                    this.show = false
                  }
                })
                .catch((res) => {
                  console.log(res);
                });
            }
          }
        }
      }
      console.log(this.clientvalue)
      if (this.clientvalue == '商机') {
        if (this.flage == true) {
          if (scrollTop + clientHeight >= scrollHeight - 20) {
            this.show = true
            this.flage = false
            this.page = this.page + 1
            var params = {
              qw_user_id: this.$t.qiwei_yuangong_num,
              khmc: this.uservalue,
              page: this.page,
              limit: '5'
            }
            this.$axios
              .get(qiweiAPI.getOpportunityData, {
                params,
                headers: this.$t.headers,
              })
              .then((res) => {
                console.log(res)
                if (res.data.code == 1) {
                  this.flage = true
                  this.show = false
                  this.clientlist = this.clientlist.concat(res.data.data.data)
                } else {
                  this.show = false
                }
              })
              .catch((res) => {
                console.log(res);
              });
          }
        }
      }

    },
    // 客户大客户一级标签选择
    onClick(index, name, title) {
      this.uservalue = ''
      this.page = 1
      this.clientlist = []
      this.show = true
      this.clientvalue = name
      if (index == 0 || index == 1) {
        this.clientvaluenum = 0
        this.clientvalue2 = '全部客户'
        var data = {
          customer: this.clientvalue,
          type: this.clientvalue2,
          qw_user_id: this.$t.qiwei_yuangong_num,
          khbmccc: this.uservalue,
        }
        this.getCustomersData(data)
      }
      if (index == 2) {
        this.getOpportunityData({
          page: this.page,
          qw_user_id: this.$t.qiwei_yuangong_num,
          khmc: this.uservalue,
          limit: '5',
        })
      }
      if (index == 3) {
        this.getTripData({
          page: this.page,
          qw_user_id: this.$t.qiwei_yuangong_num,
          limit: '1000',
        })
      }
    },
    // 客户大客户二级标签选择
    neibuclick(index, name) {
      this.clientlist = [];
      this.uservalue = ''
      this.page = 1
      this.show = true
      // console.log(index, name, title);
      this.clientvalue2 = name
      if (name == '高开工设备') {
        this.getGaoKaoData()
      } else {
        var data = {
          customer: this.clientvalue,
          type: this.clientvalue2,
          qw_user_id: this.$t.qiwei_yuangong_num,
          khbmccc: this.uservalue,
        }
        this.getCustomersData(data)
      }

    },
    // 搜索框客户
    userinput() {
      this.page = 1
      if (this.clientvalue2 == '高开工设备') {
        this.getGaoKaoData()
      } else {
        var data = {
          customer: this.clientvalue,
          type: this.clientvalue2,
          qw_user_id: this.$t.qiwei_yuangong_num,
          khbmccc: this.uservalue,

        }
        this.getCustomersData(data)
      }

    },
    // 搜索框商机
    shangjiinput() {
      this.page = 1
      this.getOpportunityData({
        page: this.page,
        qw_user_id: this.$t.qiwei_yuangong_num,
        khmc: this.uservalue,
        limit: '5',
      })
    },
    // crm客户列表
    getCustomersData(params) {
      this.show = true
      params.page = this.page
      params.limit = '5'
      console.log(qiweiAPI)
      this.$axios
        .get(qiweiAPI.getCustomersData, {
          params,
          headers: this.$t.headers,
        })
        .then((res) => {
          console.log(res)
          if (res.data.code == 1) {
            this.show = false
            this.clientlist = res.data.data.data
          } else {
            this.show = false
          }
        })
        .catch((res) => {
          console.log(res);
        });
    },
    // crm客户商机列表
    getOpportunityData(params) {
      this.$axios
        .get(qiweiAPI.getOpportunityData, {
          params,
          headers: this.$t.headers,
        })
        .then((res) => {
          console.log(res)
          if (res.data.code == 1) {
            this.show = false
            this.clientlist = res.data.data.data

          } else {
            this.show = false
          }
        })
        .catch((res) => {
          console.log(res);
        });
    },
    // 高开工列表
    getGaoKaoData(params) {
      var params = {
        qw_user_id: this.$t.qiwei_yuangong_num,
        // qw_user_id: 'HBB0458',
        khbmccc: this.uservalue,
        page: this.page,
        limit: '5'
      }
      this.$axios
        .get(qiweiAPI.getDeviceCustome, {
          params,
          headers: this.$t.headers,
        })
        .then((res) => {
          console.log(res)
          if (res.data.code == 1) {
            this.show = false
            this.clientlist = res.data.data.data
          } else {
            this.show = false
          }
        })
        .catch((res) => {
          console.log(res);
        });
    },
    // crm客户出差列表
    getTripData(params) {
      this.$axios
        .get(qiweiAPI.getTripData, {
          params,
          headers: this.$t.headers,
        })
        .then((res) => {
          console.log(res)
          if (res.data.code == 1) {
            this.show = false
            this.clientlist = res.data.data.data

          } else {
            this.show = false
          }
        })
        .catch((res) => {
          console.log(res);
        });
    },
    // crm获取用户员工号
    getuserinfo(params) {
      this.show = true
      this.$axios
        .get(qiweiAPI.getuserinfo, {
          params,
          headers: this.$t.headers,
        })
        .then((res) => {
          console.log(res)

          if (res.data.code == 1) {
            this.usernum = res.data.data
            this.$t.qiwei_yuangong_num = res.data.data
            this.$t.codefalse = 2
            this.getCustomersData({
              customer: '客户',
              type: '全部客户',
              qw_user_id: this.$t.qiwei_yuangong_num,
            })
          }
        })
        .catch((res) => {
          console.log(res);
        });
    },
    onClicknoFollowUp(params) {
      params.qw_user_id = this.$t.qiwei_yuangong_num;
      this.$axios
        .get(qiweiAPI.noFollowUp, {
          params,
          headers: this.$t.headers,
        })
        .then((res) => {
          console.log(res)
          if (res.data.code == 1) {
            this.getGaoKaoData()
            this.$toast.success('暂不跟进成功')
          }
        })
        .catch((res) => {
          console.log(res);
        });
    },
  },

  components: {
    Nav,
    kuhuList,
    fooalt
  }

}
</script>

<style>
.main {
  width: 100%;
  height: 100%;
  /* 设置一个固定高度 */
  overflow: hidden
}

.nav {
  width: 100%;
}

.kuhuList {
  margin-top: 15px;
}

.content {
  padding-bottom: 60px;
}

.scroll-container {
  height: 700px;
  /* 设置一个固定高度 */
  overflow-y: auto;
  /* 开启垂直滚动 */
}
</style>


// WEBPACK FOOTER //
// src/pages/qiwei/mianqian.vue